import moment from "moment";
import { DateSchema } from "yup";

export const FILE_ACCESS_URL = process.env.REACT_APP_FILE_ACCESS;

export const countryCodes = [
  { id: "cc1", name: "India", label: "🇮🇳 +91", value: "+91" },
  { id: "cc2", name: "United States", label: "🇺🇸 +1", value: "+1" },
  { id: "cc3", name: "United Kingdom", label: "🇬🇧 +44", value: "+44" },
  { id: "cc4", name: "Australia", label: "🇦🇺 +61", value: "+61" },
  { id: "cc5", name: "Canada", label: "🇨🇦 +1", value: "+1" },
  { id: "cc6", name: "New Zealand", label: "🇳🇿 +64", value: "+64" },
  { id: "cc7", name: "Singapore", label: "🇸🇬 +65", value: "+65" },
  { id: "cc8", name: "Germany", label: "🇩🇪 +49", value: "+49" },
  { id: "cc9", name: "France", label: "🇫🇷 +33", value: "+33" },
  { id: "cc10", name: "United Arab Emirates", label: "🇦🇪 +971", value: "+971" },
];

export const _CasteData = [
  { id: "c1", name: "General", label: "General", value: "general" },
  { id: "c2", name: "OBC", label: "OBC", value: "obc" },
  { id: "c3", name: "BC", label: "BC", value: "bc" },
  { id: "c4", name: "SC", label: "SC", value: "sc" },
  { id: "c5", name: "ST", label: "ST", value: "st" },
  { id: "c6", name: "Other", label: "Other", value: "oc" },
];

export const _GenderData = [
  { id: "g1", name: "Male", label: "Male", value: "male" },
  { id: "g2", name: "Female", label: "Female", value: "female" },
  { id: "g3", name: "Other", label: "Other", value: "other" },
];
export const _HearOption = [
  { id: "ho1", label: "Social media", value: "social media" },
  { id: "ho2", label: "Newspaper", value: "newspaper" },
  { id: "ho3", label: "Google", value: "google" },
  { id: "ho4", label: "Other", value: "other" },
];
export const father_RelationshipData = [
  { id: "r1", label: "Father", value: "father" },
];
export const mother_RelationshipData = [
  { id: "r1", label: "Mother", value: "mother" },
];
export const _RelationshipData = [
  { id: "r1", label: "Uncle", value: "uncle" },
  { id: "r1", label: "Aunty", value: "aunty" },
];

export const _Marital_status = [
  { value: "single", label: "Single" },
  { value: "married", label: "Married" },
  { value: "divorced", label: "Divorced" },
  { value: "widowed", label: "Widowed" },
];

export const _Priority = [
  { value: 0, label: "Low" },
  { value: 1, label: "High" },
];

export const _Holiday_type = [
  { value: "fullDay", label: "Full Day" },
  { value: "firstHalf", label: "First Half" },
  { value: "secondHalf", label: "Second Half" },
];

export const _Vehicle_type = [
  { value: "Mini School Buses", label: "Mini School Buses" },
  { value: "Medium-Sized School Buses", label: "Medium-Sized School Buses" },
  { value: "Large School Buses", label: "Large School Buses" },
  { value: "Custom School Vans", label: "Custom School Vans" },
  { value: "Electric School Buses", label: "Electric School Buses" },
];

export const _vehicle_fuel_type = [
  { value: "Petrol", label: "Petrol" },
  { value: "Diesel", label: "Diesel" },
  { value: "CNG", label: "CNG" },
  { value: "Electric", label: "Electric" },
  { value: "Bio-Diesel", label: "Bio-Diesel" },
  { value: "Liquid Petroleum Gas", label: "Liquid Petroleum Gas" },
  { value: "Ethanol", label: "Ethanol" },
  { value: "Methanol", label: "Methanol" },
  { value: "Hydrogen", label: "Hydrogen" },
  { value: "Hybrid", label: "Hybrid" },
  { value: "Solar Powered", label: "Solar Powered" },
];

export const __License_type = [
  { value: "Invalid Carriage", label: "Invalid Carriage" },
  { value: "Light Motor Vehicle (NT)", label: "Light Motor Vehicle (NT)" },
  { value: "Transport Vehicles", label: "Transport Vehicles" },
  { value: "Heavy goods vehicle (HGV)", label: "Heavy goods vehicle (HGV)" },
  {
    value: "Heavy passenger vehicle (HPV)",
    label: "Heavy passenger vehicle (HPV)",
  },
  {
    value: "Motor Vehicles of a specified description",
    label: "Motor Vehicles of a specified description",
  },
  { value: "Other", label: "Other" },
];

export const _Teaching_Data = [
  { id: "t1", name: "Yes", value: 1 },
  { id: "t2", name: "No", value: 0 },
];

export const urgencyData = [
  { label: "Low", value: "0" },
  { label: "Medium", value: "1" },
  { label: "High", value: "2" },
];

export const _circularCategories = [
  { label: "Academic", value: "Academic" },
  { label: "Events", value: "Events" },
  { label: "Examinations", value: "Examinations" },
  { label: "Holidays", value: "Holidays" },
  { label: "General Notices", value: "General Notices" },
];

export const _Fee_Head = [
  {
    value: "fee",
    label: "Fee",
  },
  {
    value: "student",
    label: "Student",
  },
  {
    value: "transport",
    label: "Transport",
  },
];

export const _YES_NO = [
  {
    value: 1,
    label: "Yes",
  },
  {
    value: 0,
    label: "No",
  },
];

export const _Users_Type = [
  { id: "t1", label: "Student", value: 1 },
  { id: "t2", label: "Staff", value: 2 },
  // { id: "t3", label: "Both", value: 3 },
];

export const _Invoice_type = [
  { id: "t2", label: "Class", value: 1 },
  // { id: "t1", label: "Student", value: 2 },
];

export const _Receipt_type = [
  { id: "t2", label: "Fee", value: "fee" },
  { id: "t1", label: "Fine", value: "fine" },
  { id: "t1", label: "Transport", value: "transport" },
];

export const _Amount_type = [
  { label: "Fixed/Flat", value: 1 },
  { label: "Percentage", value: 2 },
];

export const _Leave_type = [
  {id:"short", label: "Short Leave", value: 1 },
  {id:"half", label: "Half Day Leave", value: 2 },
  {id:"full", label: "Full Day Leave", value: 3 },
];

export const _Deduction_type = [ 
  {id:"paid", label: "Paid Leave", value: 1 },
  {id:"unpaid", label: "Unpaid Leave", value: 2 },
] 

export const _mark_for = [ 
  {id:"full_day", label: "Full Day", value: 1 },
  {id:"first_half", label: "First half", value: 2 },
  {id:"second_half", label: "Second half", value: 3 },
] 

export const status_type = [ 
   { id: "present", value: "present", name: "Present" },
  { id: "absent", value: "absent", name: "Absent" },
  { id: "leave", value: "leave", name: "Leave" },
] 

export const _Salary_type = [
  {id:"fixed", label: "Fixed Salary", value: 1 },
  {id:"commission", label: "Commission Based", value: 2 },
];

export const _Fee_Frequency_type = [
  { label: "Daily", value: 1 },
  { label: "Weekly", value: 2 },
  { label: "Monthly", value: 3 },
];

export const _attendanceOptionsList = [
  { id: "present", name: "P", value: 1 },
  { id: "absent", name: "A", value: 0 },
  { id: "leave", name: "L", value: 2 },
];

export const _notebookOptionsList = [
  { id: "yes", name: "Checked", value: 1 },
  { id: "no", name: "Pending", value: 0 },
];

export const _promoteOptionsList = [
  { id: "continue", name: "Promote", value: 1 },

  { id: "leave", name: "Left", value: 0 },
];

export const _respondentsList = [
  { label: "Group", value: 1 },
  { label: "Individuals", value: 2 },
];

export const _Roles = [
  { label: "Teacher", value: "teacher" },
  { label: "Helper", value: "helper" },
  { label: "Transport", value: "transport" },
  { label: "Gatekeeper", value: "gatekeeper" },
];

export const _questionTypeOption = [
  { value: 1, label: "Text" },
  { value: 2, label: "Multiple Choice (MCQ)" },
  { value: 3, label: "True/False" },
];

export const _StockType = [
  { value: '0', label: "Consumable" },
  { value: '1', label: "Fixed" },
];

export const _userRole = {
  SUPER_ADMIN: "SUPER_ADMIN",
  WORKSPACE_ADMIN: "WORKSPACE_ADMIN",
  STAFF: "STAFF",
  STUDENT: "STUDENT",
  CONTACT: "CONTACT",
};

export const importOptions = [
  { name: "Quick Import", value: "short" },
  { name: "Full Import", value: "long" },
];

export const _examFormats = [
  { id: "t1", label: "Theoretical", value: 1 },
  { id: "t2", label: "Practical", value: 0 },
];

export const _amount_type = [
  { id: "amount_type_1", label: "Fixed Amount", value: 1 },
  { id: "amount_type_2", label: "Percentage (%)", value: 2 },
];

export const _NationalityData = [
  {
    id: "n1",
    name: "Indian",
    label: "Indian",
    value: "indian",
    isDefault: true,
  },
  { id: "n2", name: "Afghan", label: "Afghan", value: "afghan" },
  { id: "n3", name: "Albanian", label: "Albanian", value: "albanian" },
  { id: "n4", name: "Algerian", label: "Algerian", value: "algerian" },
  { id: "n5", name: "American", label: "American", value: "american" },
  { id: "n6", name: "Andorran", label: "Andorran", value: "andorran" },
  { id: "n7", name: "Angolan", label: "Angolan", value: "angolan" },
  { id: "n8", name: "Argentine", label: "Argentine", value: "argentine" },
  { id: "n9", name: "Armenian", label: "Armenian", value: "armenian" },
  { id: "n10", name: "Australian", label: "Australian", value: "australian" },
  { id: "n11", name: "Austrian", label: "Austrian", value: "austrian" },
  {
    id: "n12",
    name: "Azerbaijani",
    label: "Azerbaijani",
    value: "azerbaijani",
  },
  {
    id: "n13",
    name: "Bangladeshi",
    label: "Bangladeshi",
    value: "bangladeshi",
  },
  { id: "n14", name: "Belgian", label: "Belgian", value: "belgian" },
  { id: "n15", name: "Bhutanese", label: "Bhutanese", value: "bhutanese" },
  { id: "n16", name: "Brazilian", label: "Brazilian", value: "brazilian" },
  { id: "n17", name: "British", label: "British", value: "british" },
  { id: "n18", name: "Canadian", label: "Canadian", value: "canadian" },
  { id: "n19", name: "Chinese", label: "Chinese", value: "chinese" },
  { id: "n20", name: "Danish", label: "Danish", value: "danish" },
  { id: "n21", name: "Egyptian", label: "Egyptian", value: "egyptian" },
  { id: "n22", name: "Finnish", label: "Finnish", value: "finnish" },
  { id: "n23", name: "French", label: "French", value: "french" },
  { id: "n24", name: "German", label: "German", value: "german" },
  { id: "n25", name: "Greek", label: "Greek", value: "greek" },
  { id: "n26", name: "Indonesian", label: "Indonesian", value: "indonesian" },
  { id: "n27", name: "Iranian", label: "Iranian", value: "iranian" },
  { id: "n28", name: "Iraqi", label: "Iraqi", value: "iraqi" },
  { id: "n29", name: "Irish", label: "Irish", value: "irish" },
  { id: "n30", name: "Israeli", label: "Israeli", value: "israeli" },
  { id: "n31", name: "Italian", label: "Italian", value: "italian" },
  { id: "n32", name: "Japanese", label: "Japanese", value: "japanese" },
  { id: "n33", name: "Kenyan", label: "Kenyan", value: "kenyan" },
  { id: "n34", name: "Kuwaiti", label: "Kuwaiti", value: "kuwaiti" },
  { id: "n35", name: "Malaysian", label: "Malaysian", value: "malaysian" },
  { id: "n36", name: "Mexican", label: "Mexican", value: "mexican" },
  { id: "n37", name: "Nepali", label: "Nepali", value: "nepali" },
  { id: "n38", name: "Nigerian", label: "Nigerian", value: "nigerian" },
  { id: "n39", name: "Norwegian", label: "Norwegian", value: "norwegian" },
  { id: "n40", name: "Pakistani", label: "Pakistani", value: "pakistani" },
  { id: "n41", name: "Russian", label: "Russian", value: "russian" },
  {
    id: "n42",
    name: "Singaporean",
    label: "Singaporean",
    value: "singaporean",
  },
  {
    id: "n43",
    name: "South African",
    label: "South African",
    value: "south_african",
  },
  {
    id: "n44",
    name: "South Korean",
    label: "South Korean",
    value: "south_korean",
  },
  { id: "n45", name: "Spanish", label: "Spanish", value: "spanish" },
  { id: "n46", name: "Sri Lankan", label: "Sri Lankan", value: "sri_lankan" },
  { id: "n47", name: "Swedish", label: "Swedish", value: "swedish" },
  { id: "n48", name: "Swiss", label: "Swiss", value: "swiss" },
  { id: "n49", name: "Thai", label: "Thai", value: "thai" },
  { id: "n50", name: "Turkish", label: "Turkish", value: "turkish" },
  { id: "n51", name: "Ukrainian", label: "Ukrainian", value: "ukrainian" },
  { id: "n52", name: "Emirati", label: "Emirati", value: "emirati" },
  {
    id: "n53",
    name: "British Virgin Islander",
    label: "British Virgin Islander",
    value: "british_virgin_islander",
  },
  { id: "n54", name: "Vietnamese", label: "Vietnamese", value: "vietnamese" },
  { id: "n55", name: "Zimbabwean", label: "Zimbabwean", value: "zimbabwean" },
  { id: "n56", name: "Other", label: "Other", value: "other" },
];

export const _transformPayload = (obj) => {
  const transformedObj = {};

  for (const key in obj) {
    if (key === "documents") {
      // Specific formatting for the "documents" key
      transformedObj[key] = obj[key]?.length
        ? obj[key]
          .filter((item) => item?.uploadUrl)
          .map((item) => item?.uploadUrl || item?.url || "")
        : [];
    } else if (key.includes("logo")) {
      transformedObj[key] = obj[key].uploadUrl;
    } else if (Array.isArray(obj[key])) {
      // General transformation for arrays
      transformedObj[key] = obj[key].map((item) => {
        if (item && typeof item === "object" && "value" in item) {
          return item.value;
        }
        return item;
      });
    } else if (
      obj[key] && // Ensure obj[key] is not null or undefined
      typeof obj[key] === "object" &&
      "label" in obj[key] &&
      "value" in obj[key]
    ) {
      // Transformation for objects with "label" and "value" keys
      transformedObj[key] = obj[key].value;
    } else {
      // Default case
      transformedObj[key] = obj[key];
    }
  }

  return transformedObj;
};

export const convertToLabelValue = (items = [], needUser = false) => {
  return items.map((item) => {
    const result = {
      value: needUser ? item.user_id : item.id,
      label:
        item.label ||
        item.name ||
        item.first_name ||
        item.vehicle_number ||
        item.question,
      ...item,
    };

    if (item?.department && item.department?.uuid) {
      result.department = item.department.uuid;
    }

    return result;
  });
};

export const removeSpace = (data) => {
  return data.replace(/ /g, "-");
};

export const _formatObjectToLabelValue = (data) => {
  if (!data) return "";
  return {
    label: data?.label || data?.name,
    value: data?.user_id || data?.id,
    ...data,
  };
};

export const getLeaveType = (type) => {
  switch (type) {
    case "0.25":
      return "Short Leave";
    case "0.50":
      return "Half Day";
    case "1.00":
      return "Full Day";
    default:
      return "Unknown";
  }
};

export function printDateAndTime(dateInput, showTime = false) {
  if (!dateInput) {
    return "-";
  }

  // Extract the actual date string from the input
  let actualDateString = dateInput;

  // Handle object with children property (from TableCell's date variant)
  if (dateInput && typeof dateInput === "object" && dateInput.children) {
    actualDateString = dateInput.children;
  }

  // Normalize strings (trim and strip surrounding quotes)
  if (typeof actualDateString === "string") {
    actualDateString = actualDateString.trim();
    if (
      (actualDateString.startsWith("\"") && actualDateString.endsWith("\"")) ||
      (actualDateString.startsWith("'") && actualDateString.endsWith("'"))
    ) {
      actualDateString = actualDateString.slice(1, -1);
    }
  }

  // Parse the date with explicit strategies to avoid ambiguity
  let date;
  if (typeof actualDateString === "string") {
    // Prefer parsing with timezone info preserved if present
    if (
      actualDateString.includes("T") ||
      actualDateString.includes("Z") ||
      actualDateString.match(/^\d{4}-\d{2}-\d{2}T/)
    ) {
      // Use parseZone so we respect the provided offset/UTC (e.g., trailing Z)
      date = moment.parseZone(actualDateString);
    } else if (actualDateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      // YYYY-MM-DD format (strict)
      date = moment(actualDateString, "YYYY-MM-DD", true);
    } else if (actualDateString.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
      // DD/MM/YYYY format (strict)
      date = moment(actualDateString, "DD/MM/YYYY", true);
    } else if (actualDateString.match(/^\d{2}-\d{2}-\d{4}$/)) {
      // DD-MM-YYYY format (strict)
      date = moment(actualDateString, "DD-MM-YYYY", true);
    } else {
      // Fallback: let moment try to parse common locales; if that fails, try Date()
      date = moment(actualDateString);
      if (!date.isValid()) {
        const jsDate = new Date(actualDateString);
        date = moment(jsDate);
      }
    }
  } else {
    // If it's already a Date or moment-like value
    date = moment(actualDateString);
  }

  if (!date || !date.isValid()) return "-";

  return showTime
    ? date.local().format("DD MMM YYYY, hh:mm A")
    : date.local().format("DD MMM YYYY");
}

export function _getStartAndEndOfMonth(date) {
  const currentDate = new Date(date);

  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );

  const endOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Ensure two-digit month
    const day = date.getDate().toString().padStart(2, "0"); // Ensure two-digit day
    return `${year}-${month}-${day}`;
  };

  return {
    start_date: formatDate(startOfMonth),
    end_date: formatDate(endOfMonth),
  };
}

export const _formatFileSize = (sizeInBytes) => {
  if (sizeInBytes < 1024 * 1024) {
    return (sizeInBytes / 1024).toFixed(2) + " KB";
  }
  return (sizeInBytes / (1024 * 1024)).toFixed(2) + " MB";
};

export const removeDuplicatesById = (array) => {
  const seenIds = new Set();
  return array.filter((item) => {
    if (seenIds.has(item.id)) {
      return false;
    } else {
      seenIds.add(item.id);
      return true;
    }
  });
};

export const _isDate12HoursPast = (dateString) => {
  const inputDate = new Date(dateString);
  const currentDate = new Date();
  const hoursDifference = (currentDate - inputDate) / (1000 * 60 * 60);
  return hoursDifference >= 12;
};

export const _allExtensions = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "svg",
  "mp4",
  "mkv",
  "mov",
  "avi",
  "wmv",
  "webm",
  "mp3",
  "wav",
  "aac",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "xlsm",
  "csv",
  "ppt",
  "pptx",
  "ppsx",
  "pdf",
];

export const _handleEvent = (callback) => {
  return (event) => {
    event.preventDefault();
    event.stopPropagation();
    callback(event);
  };
};

export const _extractFileDetails = (filesArray = []) => {
  return filesArray && filesArray?.length
    ? filesArray.filter((item) => item?.uploadUrl).map((item) => item.uploadUrl)
    : [];
};

export const _formatFileDetails = (filesArray) => {
  return filesArray
    .filter((item) => item?.uploadUrl)
    .map(({ name, size, uploadUrl }) => ({
      name,
      size,
      url: uploadUrl, // Renaming the key for clarity if needed
      local_url: FILE_ACCESS_URL + uploadUrl,
    }));
};

export function startRunningTime(startTimeString, callback = () => null) {
  let [hours, minutes, seconds] = startTimeString
    .split(":")
    .map((num) => parseInt(num, 10));

  const currentDate = new Date();
  currentDate.setHours(hours, minutes, seconds, 0); // Set the time to the provided start time

  // Function to update running time and return the string
  const updateRunningTime = () => {
    // Increment the time by 1 second on every interval
    currentDate.setSeconds(currentDate.getSeconds() + 1);

    // Get the updated time values
    const updatedHours = currentDate.getHours();
    const updatedMinutes = currentDate.getMinutes();
    const updatedSeconds = currentDate.getSeconds();

    // Format the result as hours, minutes, and seconds
    const formattedTime = `${updatedHours
      .toString()
      .padStart(2, "0")}:${updatedMinutes
        .toString()
        .padStart(2, "0")}:${updatedSeconds.toString().padStart(2, "0")}`;

    // Call the callback function with the updated time
    callback(formattedTime);
  };

  // Call initially to give the first value
  updateRunningTime();

  // Start the interval to update the running time every second and return the interval ID
  return setInterval(updateRunningTime, 1000); // Update every 1000 ms (1 second)
}

export const calculateTotalTime = (data = []) => {
  let totalTimeInSeconds = 0;

  // Get the current time (today) using moment
  const currentTime = moment(); // Current time as a moment object
  const currentTimeInSeconds =
    currentTime.hours() * 3600 +
    currentTime.minutes() * 60 +
    currentTime.seconds();

  data.forEach((item) => {
    let currentItemTimeInSeconds = 0;

    // Priority 1: Use total_time from API if available and not "00:00:00"
    if (item.total_time && item.total_time !== "00:00:00") {
      const [hours, minutes, seconds] = item.total_time.split(":").map(Number);
      currentItemTimeInSeconds = hours * 3600 + minutes * 60 + seconds;
    }
    // Priority 2: If format_time is provided and it's not "00:00:00"
    else if (item.format_time && item.format_time !== "00:00:00") {
      const [hours, minutes, seconds] = item.format_time.split(":").map(Number);
      currentItemTimeInSeconds = hours * 3600 + minutes * 60 + seconds;
    } 
    // Priority 3: If both start_time and end_time exist, calculate the duration between them
    else if (item.start_time && item.end_time) {
      const startTime = moment(
        `${item.date} ${item.start_time}`,
        "YYYY-MM-DD HH:mm:ss"
      );
      const endTime = moment(
        `${item.date} ${item.end_time}`,
        "YYYY-MM-DD HH:mm:ss"
      );

      // Calculate the time difference in seconds
      const timeDifferenceInSeconds = Math.max(
        endTime.diff(startTime, "seconds"),
        0
      ); // Ensure no negative time

      currentItemTimeInSeconds = timeDifferenceInSeconds;
    } 
    // Priority 4: If only start_time exists (running attendance), calculate from start_time to current time
    else if (item.start_time && !item.end_time) {
      // Parse start_time using moment and the current date
      const startTime = moment(
        `${item.date} ${item.start_time}`,
        "YYYY-MM-DD HH:mm:ss"
      );

      // Calculate the time difference between start_time and current time in seconds
      const timeDifferenceInSeconds = Math.max(
        currentTime.diff(startTime, "seconds"),
        0
      ); // Ensure no negative time

      currentItemTimeInSeconds = timeDifferenceInSeconds;
    }

    totalTimeInSeconds += currentItemTimeInSeconds;
  });

  // Convert total time in seconds to hours, minutes, and seconds
  const hours = Math.floor(totalTimeInSeconds / 3600);
  const minutes = Math.floor((totalTimeInSeconds % 3600) / 60);
  const seconds = Math.floor(totalTimeInSeconds % 60);

  // Return the total time in HH:mm:ss format
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}:${String(seconds).padStart(2, "0")}`;
};

export const formatTime = (time) => {
  if (!time) return "00:00";
  const [hours, minutes] = time?.split(":")?.map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; // Converts 0 to 12 for 12-hour clock
  return `${formattedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
};

export const formatDateWithCondition = (date) => {
  if (!date) return "-"; // Return '-' if date is not provided

  const momentDate = moment(date);
  const now = moment(); // Keep `now` immutable

  if (momentDate.isSame(now, "day")) {
    return `Today, ${moment(date).format("hh:mm a")}`;
  } else if (momentDate.isSame(moment().subtract(1, "day"), "day")) {
    return `Yesterday, ${moment(date).format("hh:mm a")}`;
  } else {
    return moment(date).format("DD MMM YYYY, hh:mm a");
  }
};

export const _truncateDescription = (description, maxLength = 100) => {
  if (description.length > maxLength) {
    return description.slice(0, maxLength) + "...";
  }
  return description;
};

export const convertToIndianRupees = (num) => {
  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const getBelowHundred = (n) => {
    if (n < 20) return ones[n];
    const unit = n % 10;
    const ten = Math.floor(n / 10);
    return tens[ten] + (unit ? " " + ones[unit] : "");
  };

  const getAboveHundred = (n) => {
    if (n < 100) return getBelowHundred(n);
    const hundred = Math.floor(n / 100);
    const remainder = n % 100;
    return (
      ones[hundred] +
      " Hundred" +
      (remainder ? " and " + getBelowHundred(remainder) : "")
    );
  };

  const convertToWords = (n) => {
    if (n === 0) return "Zero";
    let result = "";

    const crore = Math.floor(n / 10000000);
    n %= 10000000;

    const lakh = Math.floor(n / 100000);
    n %= 100000;

    const thousand = Math.floor(n / 1000);
    n %= 1000;

    const hundred = Math.floor(n / 100);
    const remainder = n % 100;

    if (crore) result += getAboveHundred(crore) + " Crore ";
    if (lakh) result += getAboveHundred(lakh) + " Lakh ";
    if (thousand) result += getAboveHundred(thousand) + " Thousand ";
    if (hundred) result += ones[hundred] + " Hundred ";
    if (remainder)
      result += (result ? "and " : "") + getBelowHundred(remainder);

    return result.trim();
  };

  const [integerPart, decimalPart] = num.toString().split(".");
  let words = convertToWords(parseInt(integerPart)) + " Rupees";

  if (decimalPart) {
    words += " and " + convertToWords(parseInt(decimalPart)) + " Paise";
  }

  return words + " Only";
};

export function _categorizeByDate(data = []) {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const categories = [];

  const todayData = data.filter((item) => {
    const itemDate = new Date(item.created_at);
    return itemDate >= today && itemDate < new Date(today.getTime() + 86400000);
  });
  if (todayData.length > 0) {
    categories.push({ category: "Today", data: todayData });
  }

  const yesterdayData = data.filter((item) => {
    const itemDate = new Date(item.created_at);
    return itemDate >= yesterday && itemDate < today;
  });
  if (yesterdayData.length > 0) {
    categories.push({ category: "Yesterday", data: yesterdayData });
  }

  const othersData = data.filter((item) => {
    const itemDate = new Date(item.created_at);
    return (
      itemDate < yesterday || itemDate >= new Date(today.getTime() + 86400000)
    );
  });
  if (othersData.length > 0) {
    categories.push({ category: "Others", data: othersData });
  }

  return categories;
}

export const convertNumberToWords = (num) => {
  const units = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const scales = ["", "Thousand", "Lakh", "Crore"];

  const getWords = (n) => {
    if (n < 20) return units[n];
    if (n < 100)
      return (
        tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + units[n % 10] : "")
      );
    if (n < 1000)
      return (
        units[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 !== 0 ? " " + getWords(n % 100) : "")
      );
    return "";
  };

  const convertToIndianRupees = (amount) => {
    if (amount === 0) return "Zero Rupees Only";

    let integerPart = Math.floor(amount);
    let decimalPart = Math.round((amount % 1) * 100); // Extract two decimal places correctly
    let words = "";
    let scaleIndex = 0;

    while (integerPart > 0) {
      let chunk = integerPart % 1000;
      if (chunk) {
        words =
          getWords(chunk) +
          (scales[scaleIndex] ? " " + scales[scaleIndex] : "") +
          " " +
          words;
      }
      integerPart = Math.floor(integerPart / (scaleIndex === 0 ? 1000 : 100));
      scaleIndex++;
    }

    words = words.trim();
    words += " Rupees";

    if (decimalPart > 0) {
      words += ` and ${getWords(decimalPart)} Paise`;
    }

    return words + " Only";
  };

  return convertToIndianRupees(num);
};

export const checkEntryExit = (workSchedule) => {
  const now = moment(); // Current time

  // Parse ws_start and ws_end into moment objects
  const wsStart = moment(workSchedule.ws_start, "HH:mm:ss");
  const wsEnd = moment(workSchedule.ws_end, "HH:mm:ss");

  // Calculate the time after ws_start and add relax time
  const relaxEnd = wsStart.clone().add(workSchedule.ws_relax_time, "minutes");

  // Variable to store the results for both late entry and early exit
  const result = {
    lateEntry: false,
    lateBy: 0,
    earlyExit: false,
    earlyExitBy: 0,
  };

  // Check for late entry
  const isLate = now.isAfter(relaxEnd);
  if (isLate) {
    result.lateEntry = true;
    result.lateBy = now.diff(relaxEnd, "minutes");
  }

  // Check for early exit
  const isBeforeEnd = now.isBefore(wsEnd);
  if (isBeforeEnd) {
    result.earlyExit = true;
    result.earlyExitBy = wsEnd.diff(now, "minutes"); // Time left until ws_end
  }

  return result;
};

export const customDate = (date, format = "DD/MM/YYY") => {
  return moment(date).format(format);
};


export const adjustTimetableStartTime = (timetable, newStartTimeStr) => {
  const toMinutes = (timeStr) => {
    const [h, m] = timeStr.split(":").map(Number);
    return h * 60 + m;
  };

  const toTimeStr = (minutes) => {
    const h = String(Math.floor(minutes / 60)).padStart(2, "0");
    const m = String(minutes % 60).padStart(2, "0");
    return `${h}:${m}`;
  };

  const MAX_MINUTES_IN_A_DAY = 1440; // 24 hours

  const updatedTimetable = [];

  for (const day of timetable) {
    let currentMinutes = toMinutes(newStartTimeStr);

    const updatedData = [];

    for (let idx = 0; idx < day.data.length; idx++) {
      const period = day.data[idx];
      const start_time = toTimeStr(currentMinutes);
      const endMinutes = currentMinutes + period.duration;

      // ❗ Check if it exceeds the current day
      if (endMinutes > MAX_MINUTES_IN_A_DAY) {
        throw new Error(
          "Selected time will shift the time frame into the next day. Please review the duration and starting time."
        );
      }

      const end_time = toTimeStr(endMinutes);
      const prev_time = idx === 0 ? "" : toTimeStr(currentMinutes - day.data[idx - 1].duration);
      const next_time = idx === day.data.length - 1 ? "" : toTimeStr(endMinutes);

      updatedData.push({
        ...period,
        start_time,
        end_time,
        prev_time,
        next_time,
      });

      currentMinutes = endMinutes;
    }

    updatedTimetable.push({
      ...day,
      data: updatedData,
    });
  }

  return updatedTimetable;
};

export const formatText = (text) => {
  if (typeof text !== "string") return text;
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};


export function getFileType(url) {
  if (!url) return
  if (url.includes(".jpeg") || url.includes(".jpg") || url.includes(".png") || url.includes(".gif")) {
    return "image";
  } else if (url.includes(".pdf")) {
    return "pdf";
  } else if (url.includes(".xlsx") || url.includes(".xls") || url.includes(".xlsb")) {
    return "file";
  } else if (url.includes(".mp4") || url.includes(".avi") || url.includes(".mov") || url.includes(".wmv")) {
    return "video";
  } else if (url.includes(".mp3") || url.includes(".wav") || url.includes(".ogg") || url.includes(".flac")) {
    return "audio";
  } else {
    return "file";
  }
}

export function getFileTypeByName(fileName) {
  const imageExtensions = [".jpeg", ".jpg", ".png", ".gif"];
  const pdfExtensions = [".pdf"];
  const xlsxExtensions = [".xlsx", ".xls", ".xlsb"];
  const videoExtensions = [".mp4", ".avi", ".mov", ".wmv"];

  if (imageExtensions.some(ext => fileName.includes(ext))) {
    return "image";
  } else if (pdfExtensions.some(ext => fileName.includes(ext))) {
    return "pdf";
  } else if (xlsxExtensions.some(ext => fileName.includes(ext))) {
    return "xlsx";
  } else if (videoExtensions.some(ext => fileName.includes(ext))) {
    return "video";
  } else {
    return "file";
  }
}